import axios from "./api";

const Cards = {
  getAllInvoices() {
    return axios.get("business/invoices");
  },
  getCardByCustomerID(id){
    return axios.get(`/business/payment-methods/${id}`);
  }
};

export default Cards;
